import { StyleSheet } from "react-native"
import { baseColors, basePadding } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white
    },
    content: {
        // paddingHorizontal: basePadding.paddingHorizontal,
        // paddingVertical: basePadding.paddingVertical,
        // paddingTop:basePadding.paddingHorizontal,
        // paddingBottom:basePadding.paddingHorizontal
        paddingTop: 50
    },
    footer: {
        marginVertical: 10
    },
    removeMyAccount: { textDecorationLine: "underline", marginTop: 25 }
})

export default styles
